import AQRCode from './QRCode.vue';
export default AQRCode;


// WEBPACK FOOTER //
// ./src/packages/QRCode/index.js